import SearchedTracksList from "./SearchedTracksList";
import styled from "styled-components";
import {TTrack} from "../../types";
import {useEffect, useState} from "react";
import {getTrackHistory} from "../../services/track-history";
import {ErrorMessage} from "../ErrorMessage";
import {Subtitle} from "../Subtitle";
import {Title} from "../Title";

export type SearchHistoryProps = {
    lastSearchActionDatetime?: Date,
}

export const SearchHistoryContainer = styled.div`
    text-align: center;
    background-color: ${props => props.theme.palette.common.gray['100']};
    color: ${props => props.theme.palette.common.black};
`;


function SearchHistory(props: SearchHistoryProps) {
    const {lastSearchActionDatetime} = props;
    const [tracks, setTracks] = useState<Array<TTrack>>();
    const [hasError, setHasError] = useState<boolean>(false);

    const updateTrackHistory = () => {
        getTrackHistory()
            .then(result => {
                if (hasError) setHasError(false);
                setTracks(result);
            }).catch(() => {
            setHasError(true);
        });
    };

    useEffect(() => {

        updateTrackHistory();

        const polling = setInterval(() => {
            updateTrackHistory();
        }, 30000);

        return () => clearTimeout(polling);
    }, [lastSearchActionDatetime]);

    return (
        <SearchHistoryContainer>
            <Title>Search History</Title>
            <Subtitle>See the list of previously searched songs</Subtitle>
            {!tracks && hasError && (
                <ErrorMessage>Oops. Something went wrong, please try again.</ErrorMessage>
            )}
            <SearchedTracksList tracks={tracks} hasError={hasError}/>
        </SearchHistoryContainer>
    );
}

export default SearchHistory;
